import PropTypes from 'prop-types';
import { IconButton } from 'uikit/IconButton/IconButton';
import './CustomTabs.scss';

const CustomTabs = ({ className, isDisabled, direction, tabList, activeTab, setActiveTab }) => {
  return (
    <div className={`custom-tabs-wrapper-${direction} ${className}`}>
      {tabList?.length > 0 &&
        tabList.map((tab) => {
          const isDisabledTab = (tab?.isDisabled && tab?.isDisabled) || tab?.name === 'amlForm';

          return (
            <IconButton
              key={tab?.name}
              className={`custom-tab-button ${activeTab === tab?.name ? 'custom-tab-button-active' : ''}`}
              active={activeTab === tab?.name}
              onClick={() => setActiveTab(tab?.name)}
              Icon={tab?.icon ? tab?.icon : undefined}
              text={tab?.title}
              isDisabled={isDisabledTab}
              isTab
            />
          );
        })}
    </div>
  );
};

CustomTabs.propTypes = {
  className: PropTypes.string,
  isDisabled: PropTypes.string,
  direction: PropTypes.string.isRequired,
  activeTab: PropTypes.string,
  setActiveTab: PropTypes.func.isRequired,
  tabList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([PropTypes.elementType, PropTypes.oneOf([null])])
    })
  ).isRequired
};

export default CustomTabs;
